/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { usePlugImageContext } from "../../../context/PlugImageContext";
import { useCountryContext } from "../../../context/CountryContext";
import { useTradeOrganizationContext } from "../../../context/TradeOrganizationContext";
import { useContinentRegionContext } from "../../../context/ContinentRegionContext";
import {
  Select,
  TextArea,
  MyMessage,
  InputField,
  MyButton,
  AddPageShell,
  AddSection,
  AddSectionAnchor,
} from "../../components/Component";
import { codeOk, errorMessage } from "../../../lib/index";
import { defaultImage } from "../../../lib/libraries/imageKit/ImageKit";
import { ImageKitUpload } from "../../../ui/ImageKitLibrary";
import { FOLDERS } from "../../doseeData/utils/Utils";
import BestTimeToVisit from "../../components/BestTimeToVisit";
import TradeOrganizationCard from "./TradeOrganizationCard";
import PlugImageCard from "./PlugImageCard";
import RegionalBlocksCard from "./RegionalBlocksCard";
import { useRegionalBlocksContext } from "../../../context/RegionalBlocksContext";
import GenerateDescription from "../../doseeData/utils/GenerateDescription";
import { FaHandSparkles } from "react-icons/fa";
import { FiFlag, FiImage, FiAlignLeft } from "react-icons/fi";

const countriesRoute = "/countries";

const Add = () => {
  const { addCountry } = useCountryContext();
  const { regions, fetchRegions } = useContinentRegionContext();
  const { regionalBlocks, fetchRegionalBlocks } = useRegionalBlocksContext();
  const { plugImage, fetchPlugImages } = usePlugImageContext();
  const { tradeOrganization, fetchTradeOrganizations } =
    useTradeOrganizationContext();

  const [continentRegion, setContinentRegion] = useState<any>(null);
  const [localPlugImages, setLocalPlugImages] = useState<any>(null);
  const [localTradeOrganizations, setLocalTradeOrganizations] =
    useState<any>(null);
  const [localRegionalBlocks, setLocalRegionalBlocks] = useState<any>(null);
  const [thumbnail, setThumbnail] = useState(defaultImage);
  const [thumbnailId, setThumbnailId] = useState("img_cdn_id");
  const [thumbnailFlag, setThumbnailFlag] = useState<any>(null);
  const [thumbnailIdFlag, setThumbnailIdFlag] = useState<any>(null);

  const countryAudioURL = "no-audio";
  const [country_gdp, set_country_gdp] = useState<any>(null);
  const [country_name, set_country_name] = useState<any>(null);
  const [country_president, set_country_president] = useState<any>(null);
  const [country_neighbours, set_country_neighbours] = useState<any>(null);
  const [country_population, set_country_population] = useState<any>(null);
  const [continent_region_id, set_continent_region_id] = useState<any>(1);
  const [country_capital_city, set_country_capital_city] = useState<any>(null);
  const [country_national_symbol, set_country_national_symbol] =
    useState<any>(null);
  const [country_div_structure, set_country_div_structure] =
    useState<any>(null);
  const [internet_users, set_internet_users] = useState<any>(0);
  const [number_of_phones, set_number_of_phones] = useState<any>(0);
  const [top_level_domain, set_top_level_domain] = useState<any>(null);
  const [internet_providers, set_internet_providers] = useState<any>("none");
  const [country_description, set_country_description] = useState<any>(null);
  const [country_driving_side, set_country_driving_side] =
    useState<any>("left");
  const [tourism, set_tourism] = useState<any>("safe");
  const [safety_indicator, set_safety_indicator] = useState<any>("safe");
  const [voltage, set_voltage] = useState<any>(null);
  const [plug_note, set_plug_note] = useState<any>("none");
  const [plug_type, set_plug_type] = useState<any>(null);
  const [frequency, set_frequency] = useState<any>(null);
  const [plug_standard, set_plug_standard] = useState<any>("none");
  const [residential_voltage, set_residential_voltage] = useState<any>("none");
  const [three_phase_voltage, set_three_phase_voltage] = useState<any>("none");
  const [tiktok, set_tiktok] = useState<any>("none");
  const [twitter, set_twitter] = useState<any>("none");
  const [website, set_website] = useState<any>("none");
  const [youtube, set_youtube] = useState<any>("none");
  const [facebook, set_facebook] = useState<any>("none");
  const [instagram, set_instagram] = useState<any>("none");
  const [pinterest, set_pinterest] = useState<any>("none");
  const [ease_of_doing_business_global, set_ease_of_doing_business_global] =
    useState<any>(0);
  const [ease_of_doing_business_regional, set_ease_of_doing_business_regional] =
    useState<any>(null);
  const [
    ease_of_doing_business_continent,
    set_ease_of_doing_business_continent,
  ] = useState<any>(null);
  const [exports_goods, set_exports_goods] = useState<any>("none");
  const [exports_increase, set_exports_increase] = useState<any>("none");
  const [main_export_partners, set_main_export_partners] =
    useState<any>("none");
  const [imports_goods, set_imports_goods] = useState<any>("none");
  const [imports_increase, set_imports_increase] = useState<any>("none");
  const [main_import_partners, set_main_import_partners] =
    useState<any>("none");
  const [iso_2, set_iso_2] = useState<any>("none");
  const [iso_3, set_iso_3] = useState<any>("none");
  const [zip_code, set_zip_code] = useState<any>(null);
  const [phone_code, set_phone_code] = useState<any>(null);
  const [country_code, set_country_code] = useState<any>(null);
  const [alpha_code_2, set_alpha_code_2] = useState<any>("none");
  const [alpha_code_3, set_alpha_code_3] = useState<any>("none");
  const [map, set_map] = useState<any>(null);
  const [area, set_area] = useState<any>(null);
  const [latitude, set_latitude] = useState<any>("none");
  const [timezone, set_timezone] = useState<any>(null);
  const [longitude, set_longitude] = useState<any>("none");
  const [geographical_id, set_geographical_id] = useState<any>("none");
  const [currency_name, set_currency_name] = useState<any>(null);
  const [currency_symbol, set_currency_symbol] = useState<any>(null);
  const [convertion_rate_to_usd, set_convertion_rate_to_usd] =
    useState<any>(null);
  const [transport_name, set_transport_name] = useState<any>("none");
  const [stock_market_name, set_stock_market_name] = useState<any>("none");
  const [stock_market_info, set_stock_market_info] = useState<any>("none");
  const [stock_market_index, set_stock_market_index] = useState<any>("none");

  const [trades, setTrades] = useState<any[]>([]);
  const [tradesID, setTradesID] = useState<any[]>([]);
  const [blocks, setBlocks] = useState<any[]>([]);
  const [blocksID, setBlocksID] = useState<any[]>([]);
  const [plugs, setPlugs] = useState<any[]>([]);
  const [plugsID, setPlugsID] = useState<any[]>([]);
  const [error, setError] = useState(false);
  const [message, setErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [bestTime, setBestTime] = useState<any[]>([]);
  const [showDescriptionModal, setShowDescriptionModal] = useState<any>(null);

  const cleanFields = () => {
    setLoading(false);
    setSuccess(true);
    set_country_gdp(null);
    set_country_name(null);
    set_country_president(null);
    set_country_neighbours(null);
    set_country_population(null);
    set_country_capital_city(null);
    set_country_div_structure(null);
    set_country_national_symbol(null);
    set_internet_users(0);
    set_number_of_phones(0);
    set_top_level_domain(null);
    set_internet_providers("none");
    set_country_description(null);
    set_voltage(null);
    set_plug_note("none");
    set_plug_type(null);
    set_frequency(null);
    set_plug_standard("none");
    set_residential_voltage("none");
    set_three_phase_voltage("none");
    set_tiktok("none");
    set_twitter("none");
    set_website("none");
    set_youtube("none");
    set_facebook("none");
    set_instagram("none");
    set_pinterest("none");
    set_ease_of_doing_business_global(0);
    set_ease_of_doing_business_regional(null);
    set_ease_of_doing_business_continent(null);
    set_exports_goods("none");
    set_exports_increase("none");
    set_main_export_partners("none");
    set_imports_goods("none");
    set_imports_increase("none");
    set_main_import_partners("none");
    set_iso_2("none");
    set_iso_3("none");
    set_zip_code(null);
    set_phone_code(null);
    set_country_code(null);
    set_alpha_code_2("none");
    set_alpha_code_3("none");
    set_map(null);
    set_area(null);
    set_latitude("none");
    set_timezone(null);
    set_longitude("none");
    set_geographical_id("none");
    set_currency_name(null);
    set_currency_symbol(null);
    set_transport_name("none");
    set_stock_market_name("none");
    set_stock_market_info("none");
    set_stock_market_index("none");
    setBestTime([]);
    set_convertion_rate_to_usd(null);
  };

  useEffect(() => {
    if (!regions) {
      fetchRegions();
    } else {
      const this_region_array: any[] = [];
      regions.map((region: any) =>
        this_region_array.push({
          name: region.name,
          id: region.continent_region_id,
        }),
      );
      setContinentRegion(this_region_array);
    }

    if (!tradeOrganization) {
      fetchTradeOrganizations();
    } else {
      setLocalTradeOrganizations(tradeOrganization);
    }

    if (!regionalBlocks) {
      fetchRegionalBlocks(1, 50);
    } else {
      setLocalRegionalBlocks(regionalBlocks);
    }

    if (!plugImage) {
      fetchPlugImages();
    } else {
      setLocalPlugImages(plugImage);
    }
  }, [regions, tradeOrganization, plugImage, regionalBlocks]);

  const responses = (isError: any, _status: any, message: any) => {
    setError(isError);
    setErrorMessage(message);
  };

  const sendAddCountryRequest = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    if (!thumbnail || !thumbnailId || !thumbnailFlag || !thumbnailIdFlag) {
      setLoading(false);
      return responses(true, 400, "Image or Flag Missing");
    } else {
      await sendDBRequest();
    }
  };

  const sendDBRequest = async () => {
    const Country = {
      continent_region_id: continent_region_id,
      name: country_name,
      slug: country_name.toLowerCase().replace(/\s/g, "_"),
      thumbnail: thumbnail ? thumbnail : defaultImage,
      image_cdn_id: thumbnailId ? thumbnailId : "",
      admin_division_structure: country_div_structure,
      flag: thumbnailFlag ? thumbnailFlag : defaultImage,
      flag_cdn_id: thumbnailIdFlag ? thumbnailIdFlag : "",
      president: country_president,
      national_symbol: country_national_symbol,
      country_neighbour: country_neighbours,
      population: country_population,
      capital_city: country_capital_city,
      tld: top_level_domain,
      internet_provider: internet_providers,
      internet_users: internet_users,
      mobile_phone: number_of_phones,
      audio: countryAudioURL,
      gdp: country_gdp,
      driving_side: country_driving_side,
      tourism: tourism,
      safety_indicator: safety_indicator,
      plug_type: plug_type,
      voltage: voltage,
      plug_standard: plug_standard,
      residential_voltage: residential_voltage,
      three_phase_voltage: three_phase_voltage,
      frequency: frequency,
      plug_note: plug_note,
      youtube: youtube,
      facebook: facebook,
      twitter: twitter,
      instagram: instagram,
      pinterest: pinterest,
      tiktok: tiktok,
      website: website,
      description: country_description,
      ease_of_doing_business_regional_ranking: ease_of_doing_business_regional,
      ease_of_doing_business_continent_ranking:
        ease_of_doing_business_continent,
      ease_of_doing_business_global_ranking: ease_of_doing_business_global,
      exports_increase: exports_increase,
      exports_goods: exports_goods,
      main_export_partners: main_export_partners,
      imports_increase: imports_increase,
      imports_goods: imports_goods,
      main_import_partners: main_import_partners,
      country_code: country_code,
      zip_code: zip_code,
      phone_code: phone_code,
      alpha_code_2: alpha_code_2,
      alpha_code_3: alpha_code_3,
      iso_2_code: iso_2,
      iso_3_code: iso_3,
      currency_name: currency_name,
      currency_symbol: currency_symbol,
      convertion_rate_to_usd: convertion_rate_to_usd,
      transportation: transport_name,
      stock_market_name: stock_market_name,
      stock_market_index: stock_market_index,
      stock_market_info: stock_market_info,
      latitude: latitude,
      longitude: longitude,
      area: area,
      geo_id: geographical_id,
      map: map,
      time_zone: timezone,
      plug_images: plugsID,
      trade_organizations: tradesID,
      regional_blocks: blocksID,
      best_time_to_visit: bestTime?.length > 0 ? String(bestTime) : null,
    };

    const countryRespose = await addCountry(Country);
    if (countryRespose) {
      if (countryRespose.data.status === codeOk) {
        cleanFields();
        return responses(
          true,
          countryRespose.data.status,
          countryRespose.data.message,
        );
      } else {
        setLoading(false);
        return responses(
          true,
          countryRespose.data.status,
          countryRespose.data.message,
        );
      }
    } else {
      setLoading(false);
      return responses(true, 400, errorMessage);
    }
  };

  const sidebar = (
    <>
      <AddSectionAnchor to="media">Media</AddSectionAnchor>
      <AddSectionAnchor to="core">Core Details</AddSectionAnchor>
      <AddSectionAnchor to="description">Description</AddSectionAnchor>
      <AddSectionAnchor to="codes">Codes</AddSectionAnchor>
      <AddSectionAnchor to="geography">Geography</AddSectionAnchor>
      <AddSectionAnchor to="currency">Currency</AddSectionAnchor>
      <AddSectionAnchor to="transport">Transportation</AddSectionAnchor>
      <AddSectionAnchor to="stock">Stock Market</AddSectionAnchor>
      <AddSectionAnchor to="connectivity">Connectivity</AddSectionAnchor>
      <AddSectionAnchor to="driving">Driving</AddSectionAnchor>
      <AddSectionAnchor to="safety">Safety</AddSectionAnchor>
      <AddSectionAnchor to="electricity">Electricity</AddSectionAnchor>
      <AddSectionAnchor to="social">Social</AddSectionAnchor>
      <AddSectionAnchor to="business">Ease of Business</AddSectionAnchor>
      <AddSectionAnchor to="trade">Trade • Blocks • Plugs</AddSectionAnchor>
      <AddSectionAnchor to="imports-exports">Imports & Exports</AddSectionAnchor>
    </>
  );

  return (
    <AddPageShell
      backRoute={countriesRoute}
      eyebrow="Geography • Countries"
      title="Add a New Country"
      subtitle="Provide identity, geography, economy and connectivity to publish a new country."
      icon={<FiFlag className="h-5 w-5" />}
      size="xl"
      sidebar={sidebar}
      modals={
        showDescriptionModal ? (
          <GenerateDescription
            setDescription={set_country_description}
            setShowDescriptionModal={setShowDescriptionModal}
          />
        ) : null
      }
      loading={loading}
      submitLabel="Add Country"
      onSubmit={sendAddCountryRequest}
      onSubmitClick={() => {
        setError(false);
        setSuccess(false);
        setErrorMessage(null);
      }}
      message={
        <MyMessage
          error={error}
          message={message}
          success={success}
          onExpired={() => {
            setError(false);
            setSuccess(false);
          }}
          onClick={() => {
            setError(false);
            setSuccess(false);
            setErrorMessage("");
          }}
        />
      }
    >
      <AddSection
        id="media"
        title="Media"
        hint="Upload a country photo and the official flag. WEBP/JPG/PNG recommended."
        icon={<FiImage className="h-4 w-4" />}
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Country Photo
            </p>
            <ImageKitUpload
              thumbnail={thumbnail}
              thumbnailId={thumbnailId}
              setThumbnail={setThumbnail}
              setThumbnailId={setThumbnailId}
              folder={FOLDERS.COUNTRIES}
            />
          </div>
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Country Flag
            </p>
            <ImageKitUpload
              thumbnail={thumbnailFlag}
              thumbnailId={thumbnailIdFlag}
              setThumbnail={setThumbnailFlag}
              setThumbnailId={setThumbnailIdFlag}
              folder={FOLDERS.COUNTRIES}
            />
          </div>
        </div>
      </AddSection>

      <AddSection
        id="core"
        title="Core Details"
        hint="Primary identifiers and travel context."
      >
        <div className="mb-4">
          <p className="mb-1 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
            Best Time To Visit
          </p>
          <BestTimeToVisit bestTime={bestTime} setBestTime={setBestTime} />
        </div>
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <Select
            props={{
              id: "continent_region",
              title: "Continent Region",
              required: true,
              option: continentRegion
                ? continentRegion.map((r: any) => r.name)
                : [],
              onChange: (e: any) => {
                set_continent_region_id(
                  regions[e.target.selectedIndex].continent_region_id,
                );
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "name",
              title: "Title",
              type: "text",
              required: true,
              value: country_name ? country_name : "",
              onChange: (e: any) => {
                set_country_name(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "president",
              title: "President",
              type: "text",
              required: true,
              value: country_president ? country_president : "",
              onChange: (e: any) => {
                set_country_president(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "national_symbol",
              title: "National Symbol",
              type: "text",
              required: true,
              value: country_national_symbol ? country_national_symbol : "",
              onChange: (e: any) => {
                set_country_national_symbol(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "country_neighbour",
              title: "Neighboring Countries (comma separated)",
              type: "text",
              required: true,
              value: country_neighbours ? country_neighbours : "",
              onChange: (e: any) => {
                set_country_neighbours(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "population",
              title: "Population",
              type: "number",
              required: true,
              value: country_population ? country_population : "",
              onChange: (e: any) => {
                set_country_population(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "gdp",
              title: "GDP",
              type: "number",
              required: true,
              value: country_gdp ? country_gdp : "",
              onChange: (e: any) => {
                set_country_gdp(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "capital_city",
              title: "Capital City",
              type: "text",
              required: true,
              value: country_capital_city ? country_capital_city : "",
              onChange: (e: any) => {
                set_country_capital_city(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "administrative_division_structure",
              title: "Administrative Division Structure",
              type: "text",
              required: true,
              value: country_div_structure ? country_div_structure : "",
              onChange: (e: any) => {
                set_country_div_structure(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="description"
        title="Description"
        hint="Write or generate a descriptive overview."
        icon={<FiAlignLeft className="h-4 w-4" />}
        actions={
          <MyButton
            onClick={() => setShowDescriptionModal(true)}
            className="inline-flex items-center gap-2 rounded-lg bg-gradient-to-br from-brand to-primary px-3 py-2 text-xs font-semibold text-white shadow hover:opacity-95"
          >
            <FaHandSparkles className="h-4 w-4" />
            Generate
          </MyButton>
        }
      >
        <TextArea
          props={{
            id: "description",
            title: "Description",
            type: "text",
            value: country_description ? country_description : "",
            onChange: (e: any) => {
              set_country_description(e.target.value);
              setError(null);
              setSuccess(null);
            },
          }}
        />
      </AddSection>

      <AddSection
        id="codes"
        title="Codes"
        hint="Standards and country identifiers."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
          <InputField
            props={{
              id: "country_code",
              title: "Country Code",
              type: "text",
              required: true,
              value: country_code ? country_code : "",
              onChange: (e: any) => {
                set_country_code(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "zip_code",
              title: "Zip Code",
              type: "text",
              required: true,
              value: zip_code ? zip_code : "",
              onChange: (e: any) => {
                set_zip_code(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "phone_code",
              title: "Phone Code",
              type: "text",
              required: true,
              value: phone_code ? phone_code : "",
              onChange: (e: any) => {
                set_phone_code(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "alpha_code_2",
              title: "Alpha Code 2",
              type: "text",
              value: alpha_code_2 ? alpha_code_2 : "",
              onChange: (e: any) => {
                set_alpha_code_2(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "alpha_code_3",
              title: "Alpha Code 3",
              type: "text",
              value: alpha_code_3 ? alpha_code_3 : "",
              onChange: (e: any) => {
                set_alpha_code_3(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "iso_2",
              title: "ISO 2",
              type: "text",
              value: iso_2 ? iso_2 : "",
              onChange: (e: any) => {
                set_iso_2(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "iso_3",
              title: "ISO 3",
              type: "text",
              value: iso_3 ? iso_3 : "",
              onChange: (e: any) => {
                set_iso_3(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="geography"
        title="Geography"
        hint="Map data and coordinates."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <InputField
            props={{
              id: "latitude",
              title: "Latitude",
              type: "text",
              value: latitude ? latitude : "",
              onChange: (e: any) => {
                set_latitude(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "longitude",
              title: "Longitude",
              type: "text",
              value: longitude ? longitude : "",
              onChange: (e: any) => {
                set_longitude(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "area",
              title: "Area",
              type: "text",
              required: true,
              value: area ? area : "",
              onChange: (e: any) => {
                set_area(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "geo_id",
              title: "Geographical ID",
              type: "text",
              value: geographical_id ? geographical_id : "",
              onChange: (e: any) => {
                set_geographical_id(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "map",
              title: "Map",
              type: "text",
              required: true,
              value: map ? map : "",
              onChange: (e: any) => {
                set_map(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "time_zone",
              title: "Time Zone",
              type: "text",
              required: true,
              value: timezone ? timezone : "",
              onChange: (e: any) => {
                set_timezone(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="currency"
        title="Currency"
        hint="Local currency details."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "currency_name",
              title: "Name Of Currency",
              type: "text",
              required: true,
              value: currency_name ? currency_name : "",
              onChange: (e: any) => {
                set_currency_name(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "symbol",
              title: "Symbol Of Currency",
              type: "text",
              required: true,
              value: currency_symbol ? currency_symbol : "",
              onChange: (e: any) => {
                set_currency_symbol(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "conversion",
              title: "Convertion Rate To US Dollars",
              type: "number",
              value: convertion_rate_to_usd ? convertion_rate_to_usd : "",
              onChange: (e: any) => {
                set_convertion_rate_to_usd(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="transport"
        title="Transportation"
        hint="Dominant modes and names."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "transport_name",
              title: "Names Of Transportations",
              type: "text",
              value: transport_name ? transport_name : "",
              onChange: (e: any) => {
                set_transport_name(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="stock"
        title="Stock Market"
        hint="Local exchange data."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "stock_market_name",
              title: "Stock Market Name",
              type: "text",
              value: stock_market_name ? stock_market_name : "",
              onChange: (e: any) => {
                set_stock_market_name(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "stock_market_index",
              title: "Stock Market Index",
              type: "text",
              value: stock_market_index ? stock_market_index : "",
              onChange: (e: any) => {
                set_stock_market_index(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "stock_market_info",
              title: "Stock Market Info",
              type: "text",
              value: stock_market_info ? stock_market_info : "",
              onChange: (e: any) => {
                set_stock_market_info(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="connectivity"
        title="Connectivity"
        hint="Internet, users and telecom."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <InputField
            props={{
              id: "tld",
              title: "Top Level Domain",
              type: "text",
              required: true,
              value: top_level_domain ? top_level_domain : "",
              onChange: (e: any) => {
                set_top_level_domain(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "internet_provider",
              title: "Internet Providers",
              type: "text",
              value: internet_providers ? internet_providers : "",
              onChange: (e: any) => {
                set_internet_providers(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "internet_users",
              title: "Internet Users",
              type: "number",
              required: true,
              value: internet_users ? internet_users : "",
              onChange: (e: any) => {
                set_internet_users(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "mobile_phone",
              title: "Number Of Phones",
              type: "number",
              required: true,
              value: number_of_phones ? number_of_phones : "",
              onChange: (e: any) => {
                set_number_of_phones(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection id="driving" title="Driving" hint="Rules of the road.">
        <div className="grid grid-cols-1 gap-4 lg:grid-cols-3 xl:grid-cols-4">
          <Select
            props={{
              id: "driving_side",
              title: "Driving Side",
              required: true,
              option: ["left", "right"],
              onChange: (e: any) => {
                set_country_driving_side(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="safety"
        title="Safety & Security"
        hint="Tourism climate and safety indicator."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <Select
            props={{
              id: "tourism",
              title: "Tourism",
              required: true,
              option: ["safe", "intermediate", "danger"],
              onChange: (e: any) => {
                set_tourism(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <Select
            props={{
              id: "safety_indicator",
              title: "Safety Indicator",
              required: true,
              option: ["safe", "intermediate", "danger"],
              onChange: (e: any) => {
                set_safety_indicator(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="electricity"
        title="Electricity"
        hint="Power specs and plug standards."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-3 lg:grid-cols-4">
          <InputField
            props={{
              id: "plug_type",
              title: "Plug Type",
              type: "text",
              required: true,
              value: plug_type ? plug_type : "",
              onChange: (e: any) => {
                set_plug_type(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "voltage",
              title: "Voltage (V)",
              type: "number",
              required: true,
              value: voltage ? voltage : "",
              onChange: (e: any) => {
                set_voltage(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "plug_standard",
              title: "Plug Standard",
              type: "text",
              value: plug_standard ? plug_standard : "",
              onChange: (e: any) => {
                set_plug_standard(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "residential_voltage",
              title: "Residential Voltage",
              type: "text",
              value: residential_voltage ? residential_voltage : "",
              onChange: (e: any) => {
                set_residential_voltage(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "three_phase_voltage",
              title: "Three Phase Voltage",
              type: "text",
              value: three_phase_voltage ? three_phase_voltage : "",
              onChange: (e: any) => {
                set_three_phase_voltage(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "frequency",
              title: "Frequency",
              type: "text",
              required: true,
              value: frequency ? frequency : "",
              onChange: (e: any) => {
                set_frequency(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
        <div className="mt-4">
          <TextArea
            props={{
              id: "plug_note",
              title: "Plug Note",
              type: "text",
              value: plug_note ? plug_note : "",
              onChange: (e: any) => {
                set_plug_note(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="social"
        title="Social & Links"
        hint="Official website and social channels."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          <InputField
            props={{
              id: "website",
              title: "Website",
              type: "text",
              value: website ? website : "",
              onChange: (e: any) => {
                set_website(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "youtube",
              title: "YouTube",
              type: "text",
              value: youtube ? youtube : "",
              onChange: (e: any) => {
                set_youtube(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "facebook",
              title: "Facebook",
              type: "text",
              value: facebook ? facebook : "",
              onChange: (e: any) => {
                set_facebook(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "twitter",
              title: "Twitter",
              type: "text",
              value: twitter ? twitter : "",
              onChange: (e: any) => {
                set_twitter(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "instagram",
              title: "Instagram",
              type: "text",
              value: instagram ? instagram : "",
              onChange: (e: any) => {
                set_instagram(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "pinterest",
              title: "Pinterest",
              type: "text",
              value: pinterest ? pinterest : "",
              onChange: (e: any) => {
                set_pinterest(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "tiktok",
              title: "TikTok",
              type: "text",
              value: tiktok ? tiktok : "",
              onChange: (e: any) => {
                set_tiktok(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="business"
        title="Ease Of Doing Business"
        hint="Relative rankings."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2 lg:grid-cols-3">
          <InputField
            props={{
              id: "ease_of_doing_business_regional_ranking",
              title: "Regional Ranking",
              type: "number",
              required: true,
              value: ease_of_doing_business_regional
                ? ease_of_doing_business_regional
                : "",
              onChange: (e: any) => {
                set_ease_of_doing_business_regional(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "ease_of_doing_business_continent_ranking",
              title: "Continent Ranking",
              type: "number",
              required: true,
              value: ease_of_doing_business_continent
                ? ease_of_doing_business_continent
                : "",
              onChange: (e: any) => {
                set_ease_of_doing_business_continent(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <InputField
            props={{
              id: "ease_of_doing_business_global_ranking",
              title: "Global Ranking",
              type: "number",
              value: ease_of_doing_business_global
                ? ease_of_doing_business_global
                : "",
              onChange: (e: any) => {
                set_ease_of_doing_business_global(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>

      <AddSection
        id="trade"
        title="Trade Organisations • Regional Blocks • Plug Types"
        hint="Associate memberships and plug images."
      >
        <div className="grid grid-cols-1 gap-8">
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Trade Organisations
            </p>
            <TradeOrganizationCard
              trades={trades}
              tradesID={tradesID}
              setError={setError}
              setTrades={setTrades}
              setSuccess={setSuccess}
              setTradesID={setTradesID}
              setIsTradeChanges={() => {}}
              localTradeOrganizations={localTradeOrganizations}
            />
          </div>
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Regional Blocks
            </p>
            <RegionalBlocksCard
              blocks={blocks}
              blocksID={blocksID}
              setError={setError}
              setBlocks={setBlocks}
              setSuccess={setSuccess}
              setBlocksID={setBlocksID}
              setIsBlockChanges={() => {}}
              localRegionalBlocks={localRegionalBlocks}
            />
          </div>
          <div>
            <p className="mb-2 text-[11px] font-semibold uppercase tracking-[0.14em] text-gray-500">
              Plug Images
            </p>
            <PlugImageCard
              plugs={plugs}
              plugsID={plugsID}
              setError={setError}
              setPlugs={setPlugs}
              setPlugsID={setPlugsID}
              setSuccess={setSuccess}
              setIsPlugChanges={() => {}}
              localPlugImages={localPlugImages}
            />
          </div>
        </div>
      </AddSection>

      <AddSection
        id="imports-exports"
        title="Imports & Exports"
        hint="Free-form notes and partner lists."
      >
        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          <TextArea
            props={{
              id: "exports_increase",
              title: "Exports Increase",
              type: "text",
              value: exports_increase ? exports_increase : "",
              onChange: (e: any) => {
                set_exports_increase(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "exports_goods",
              title: "Exports Goods",
              type: "text",
              value: exports_goods ? exports_goods : "",
              onChange: (e: any) => {
                set_exports_goods(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "main_export_partners",
              title: "Main Export Partners",
              type: "text",
              value: main_export_partners ? main_export_partners : "",
              onChange: (e: any) => {
                set_main_export_partners(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "imports_increase",
              title: "Imports Increase",
              type: "text",
              value: imports_increase ? imports_increase : "",
              onChange: (e: any) => {
                set_imports_increase(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "imports_goods",
              title: "Imports Goods",
              type: "text",
              value: imports_goods ? imports_goods : "",
              onChange: (e: any) => {
                set_imports_goods(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
          <TextArea
            props={{
              id: "main_import_partners",
              title: "Main Import Partners",
              type: "text",
              value: main_import_partners ? main_import_partners : "",
              onChange: (e: any) => {
                set_main_import_partners(e.target.value);
                setError(null);
                setSuccess(null);
              },
            }}
          />
        </div>
      </AddSection>
    </AddPageShell>
  );
};

export default Add;
